import React, { useEffect, useState } from "react";
import api from "../api/api";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

function Dashboard() {
  const [vehicles, setVehicles] = useState([]);

  const [id, setId] = useState("");
  const [status, setStatus] = useState("");
  const [location, setLocation] = useState("");

  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  /* ================= FETCH ================= */

  const fetchVehicles = async () => {
    try {
      const res = await api.get("/vehicles");
      setVehicles(res.data);
      setLoading(false);
    } catch (err) {
      setError("Failed to load vehicles");
      if (err.response?.status === 401) {
        logout();
      }
    }
  };

  /* ================= LOGOUT ================= */

  const logout = () => {
    localStorage.removeItem("token");
    navigate("/api/login");
  };

  /* ================= CREATE / UPDATE ================= */

  const submitVehicle = async (e) => {
    e.preventDefault();

    if (!id || !status || !location) {
      return alert("Fill all fields");
    }

    try {
      if (isEditing) {
        await api.put(`/vehicles/${id}`, { status, location });
      } else {
        await api.post("/vehicles", { id, status, location });
      }

      resetForm();
      fetchVehicles();
    } catch {
      alert("Operation failed");
    }
  };

  /* ================= DELETE ================= */

  const deleteVehicle = async (id) => {
    if (!window.confirm("Delete vehicle?")) return;

    try {
      await api.delete(`/vehicles/${id}`);
      fetchVehicles();
    } catch {
      alert("Delete failed");
    }
  };

  /* ================= EDIT ================= */

  const editVehicle = (v) => {
    setId(v.id);
    setStatus(v.status);
    setLocation(v.location);
    setIsEditing(true);
  };

  /* ================= RESET ================= */

  const resetForm = () => {
    setId("");
    setStatus("");
    setLocation("");
    setIsEditing(false);
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  if (loading)
    return (
      <>
        <Navbar />
        <h2 style={{ textAlign: "center", marginTop: "40px" }}>
          Loading...
        </h2>
      </>
    );

  if (error)
    return (
      <>
        <Navbar />
        <h2 style={{ textAlign: "center", marginTop: "40px" }}>
          {error}
        </h2>
      </>
    );

  return (
    <>
      <Navbar />

      <div style={container}>
        {/* HEADER */}
        <div style={header}>
          <h1>Vehicle Management Dashboard 🚗</h1>
          <button onClick={logout} style={logoutBtn}>
            Logout
          </button>
        </div>

        {/* FORM CARD */}
        <div style={card}>
          <h2>{isEditing ? "Edit Vehicle" : "Add Vehicle"}</h2>

          <form onSubmit={submitVehicle} style={form}>
            <input
              placeholder="Vehicle ID"
              value={id}
              onChange={(e) => setId(e.target.value)}
              disabled={isEditing}
              style={input}
            />

            <input
              placeholder="Status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              style={input}
            />

            <input
              placeholder="Location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              style={input}
            />

            <button type="submit" style={primaryBtn}>
              {isEditing ? "Update" : "Add"}
            </button>

            {isEditing && (
              <button
                type="button"
                onClick={resetForm}
                style={secondaryBtn}
              >
                Cancel
              </button>
            )}
          </form>
        </div>

        {/* TABLE CARD */}
        <div style={card}>
          <h2>Vehicle List</h2>

          {vehicles.length === 0 ? (
            <p>No vehicles found.</p>
          ) : (
            <table style={table}>
              <thead>
                <tr>
                  <th style={th}>ID</th>
                  <th style={th}>Status</th>
                  <th style={th}>Location</th>
                  <th style={th}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {vehicles.map((v) => (
                  <tr key={v.id} style={row}>
                    <td style={td}>{v.id}</td>
                    <td style={td}>{v.status}</td>
                    <td style={td}>{v.location}</td>
                    <td style={td}>
                      <div style={actionsCell}>
                        <button
                          onClick={() => editVehicle(v)}
                          style={editBtn}
                        >
                          Edit
                        </button>

                        <button
                          onClick={() => deleteVehicle(v.id)}
                          style={deleteBtn}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}

export default Dashboard;

/* ================= STYLES ================= */

const container = {
  minHeight: "calc(100vh - 80px)",
  padding: "40px 20px",
  background: "#f4f6f9",
};

const header = {
  maxWidth: "1100px",
  margin: "0 auto 30px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const card = {
  maxWidth: "1100px",
  margin: "0 auto 30px",
  padding: "25px",
  background: "#fff",
  borderRadius: "10px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
};

const form = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: "15px",
  marginTop: "15px",
};

const input = {
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "14px",
};

const table = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "15px",
};

const th = {
  textAlign: "left",
  padding: "12px",
  borderBottom: "2px solid #eee",
  fontWeight: "600",
  background: "#fafafa",
};

const td = {
  padding: "12px",
  borderBottom: "1px solid #eee",
};

const row = {
  transition: "background 0.2s ease",
};

const actionsCell = {
  display: "flex",
  gap: "8px",
};

const logoutBtn = {
  background: "#000",
  color: "#fff",
  padding: "8px 18px",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

const primaryBtn = {
  background: "#000",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  padding: "10px",
  cursor: "pointer",
};

const secondaryBtn = {
  background: "#aaa",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  padding: "10px",
  cursor: "pointer",
};

const editBtn = {
  background: "#f39c12",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  padding: "6px 12px",
  cursor: "pointer",
};

const deleteBtn = {
  background: "#e74c3c",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  padding: "6px 12px",
  cursor: "pointer",
};
